import { render } from "./BasePagination.vue?vue&type=template&id=6129a26d&ts=true"
import script from "./BasePagination.vue?vue&type=script&lang=ts"
export * from "./BasePagination.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__